import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RequiredLabel extends Component {
  static defaultProps = {
    required: false
  }

  static propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool
  }

  render() {
    let { required, label } = this.props
    return required ? (
      <span>
        {label}
        <span style={{ color: 'red', fontSize: '12px' }}>*</span>
      </span>
    ) : (
      <span>{label}</span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/requiredLabel.js